// extracted by mini-css-extract-plugin
export default {"introduction":"style_introduction__S06NP"};